// @flow

import React from 'react';
import NavLink from 'src/components/NavLink/NavLink';
import {
  Text,
  TextLink,
  Rating,
  Paragraph,
  Card,
  Section
} from 'seek-style-guide/react';

import MoreJobsLink from '../MoreJobsLink/MoreJobsLink';

type Props = {
  companyReview: CompanyReview,
  advertiser: EnrichedAdvertiser
};

const CompanyReviewCard = ({ companyReview, advertiser }: Props) => {
  const {
    companyName,
    companyProfileUrl,
    companyTotalReviews,
    companyOverallRating
  } = companyReview;

  return (
    <Card transparent>
      <Section
        role="region"
        aria-labelledby="companyReview"
        data-automation="company-review"
      >
        <h1 id="companyReview">
          <Text heading data-automation="company-review-title">
            {`About ${companyName}`}
          </Text>
        </h1>

        <Paragraph>
          <Rating showTextRating rating={companyOverallRating} />
        </Paragraph>

        <Paragraph>
          <Text small raw>
            <NavLink
              data-automation="company-review-link"
              rel="nofollow"
              location={companyProfileUrl}
              component={TextLink}
              analytics="job-details-company-profile-side-clicked"
            >
              {`${companyTotalReviews} employee reviews`}
            </NavLink>
          </Text>
        </Paragraph>
        <MoreJobsLink
          small
          advertiser={advertiser}
          analytics="job-details-more-jobs-side-clicked"
        />
      </Section>
    </Card>
  );
};

export default CompanyReviewCard;
